module.exports = __webpack_public_path__ + "static/media/ct_unknown.png";